//Library Imports
import React from 'react'
import PageShell from '../../PageShell'

import BillingIntegrations from './Sections/BillingIntegrations'
import Scheduling from './Sections/Scheduling'
import SessionNotes from './Sections/SessionNotes'

const PracticeManagement = () => (
    <PageShell
        title="Practice Management"
        blurb="Frustration free, often automatic practice management"
        img={require('assets/img/practice-bg.jpg')}
        components={[
            <SessionNotes key={0} />,
            <Scheduling key={1} />,
            <BillingIntegrations key={2} />
        ]}
    />
)

export default PracticeManagement



// WEBPACK FOOTER //
// ./src/views/Features/PracticeManagement/PracticeManagement.jsx